export default "__VITE_ASSET__DeGdY_13__"